export default __webpack_public_path__ + "static/media/icon_center_align.079c753f.svg";